import { Dealer } from "../api/service";

export const useDealer = () => {
  const queryKeys = {
    getById: (id: string) => [Dealer._routes.getById, id],
    getDataMainById: (id: string) => [Dealer._routes.getDataMain, id],
    getPassportMainDataById: (id: string) => [
      Dealer._routes.getPassportMainData,
      id,
    ],
  };

  const getById = Dealer.GET.getById;
  const getDataMain = Dealer.GET.getDataMain;
  const getDealerMetrics = Dealer.GET.dealerMetrics;
  const getPassportMainData = Dealer.GET.getPassportMainData;
  const updateBlockQuality = Dealer.POST.update;

  return {
    queryKeys,
    getById,
    getDataMain,
    getPassportMainData,
    getDealerMetrics,
    updateBlockQuality,
  };
};
